import axios from "axios";
import { getBaseUrl } from "./urls";
export const FETCH_POSTS_FEED_DATA = "FETCH_POSTS_FEED_DATA";

export const fetchPostsFeedData = filters => {
    let token = localStorage.getItem("token");
    filters += "&access-token=" + token;
    filters += "&recordsPerPage=100";

    let res = axios
        .post(`${getBaseUrl()}/search`, filters, {
            cache: false,
            headers: {
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8"
            }
        })
        .then(res => res.data);

    return {
        type: FETCH_POSTS_FEED_DATA,
        payload: res
    };
};
